import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/press-kit/components/PressKitView.tsx");
